import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '../api/client.js';

interface UiConfigState {
  configuratorVisible: boolean;
  loaded: boolean;
}

const initialState: UiConfigState = {
  configuratorVisible: true,
  loaded: false,
};

// Laedt die globalen UI-Flags (aktuell: Konfigurator-Sichtbarkeit) fuer eingeloggte Nutzer.
export const fetchUiConfig = createAsyncThunk('uiConfig/fetch', async (_, { rejectWithValue }) => {
  const res = await api.get<{ configurator_visible: boolean }>('/auth/ui-config');
  if (!res.success) return rejectWithValue(res.error.message);
  return res.data.configurator_visible;
});

const uiConfigSlice = createSlice({
  name: 'uiConfig',
  initialState,
  reducers: {
    // Wird nach dem Umschalten im Admin gesetzt, damit die Menueleiste sofort reagiert (ohne Reload).
    setConfiguratorVisible(state, action: PayloadAction<boolean>) {
      state.configuratorVisible = action.payload;
      state.loaded = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUiConfig.fulfilled, (state, action: PayloadAction<boolean>) => {
      state.configuratorVisible = action.payload;
      state.loaded = true;
    });
  },
});

export const { setConfiguratorVisible } = uiConfigSlice.actions;
export default uiConfigSlice.reducer;
